// Global runtime polyfills, installed once at app entry (imported for its
// side effect from main.tsx). Kept here — not in a component file — so the
// augmentation loads reliably regardless of which components happen to mount,
// and so no component pollutes the global prototype on its own. Several
// callers (WavetablePanel, useExportJobs, …) rely on Number.prototype.clamp.

declare global {
  interface Number {
    /** Clamp this number to the inclusive [min, max] range. */
    clamp(min: number, max: number): number;
  }
}

if (!Number.prototype.clamp) {
  Number.prototype.clamp = function (this: number, min: number, max: number): number {
    return Math.min(Math.max(this, min), max);
  };
}

export {};
